import request from '@/axios'

// 获取自动分析配置开关
export function getConfig(data) {
  return request({
    url: '/inside/badge/rule/getConfig',
    data
  })
}

// 保存自动分析配置开关
export function saveConfig(data) {
  return request({
    url: '/inside/badge/rule/enable',
    data
  })
}

// 自动分析配置列表
export function getBadgeRuleList(data) {
  return request({
    url: '/inside/badge/rule/list',
    data
  })
}

// 自动分析配置新建
export function addBadgeRule(data) {
  return request({
    url: '/inside/badge/rule/add',
    data
  })
}

// 自动分析配置编辑
export function editBadgeRule(data) {
  return request({
    url: '/inside/badge/rule/edit',
    data
  })
}

// 自动分析配置删除
export function deleteBadgeRule(data) {
  return request({
    url: '/inside/badge/rule/delete',
    data
  })
}

// 自动分析配置排序
export function sortBadgeRule(data) {
  return request({
    url: '/inside/badge/rule/sort',
    data
  })
}

// 入库数据列表
export function getAnalyzeList(data) {
  return request({
    url: '/inside/badge/analyze/list',
    data
  })
}

// 入库数据重新提交分析
export function submitAnalyze(data) {
  return request({
    url: '/inside/badge/analyze/submit',
    data
  })
}

// 获取找客助手使用列表
export function getAntAccessUseList(data) {
  return request({
    url: '/inside/ant/access/useList',
    data
  })
}

// 保存配置
export function assignAntAccess(data) {
  return request({
    url: '/inside/ant/access/assign',
    data
  })
}

// 获取销售订单分析配置
export function getSalesConfig(data) {
  return request({
    url: '/inside/processConfig/get',
    data
  })
}

// 更新分析对象
export function updateAnalyzeObject(data) {
  return request({
    url: '/inside/processConfig/updateAnalyzeObject',
    data
  })
}

// 更新分析规则
export function updateAnalyzeRule(data) {
  return request({
    url: '/inside/processConfig/updateAnalyzeRule',
    data
  })
}

// 获取角色列表
export function getRoleList(data) {
  return request({
    url: '/role/list',
    data
  })
}

// 获取角色详情
export function getRoleModuleDetail(data) {
  return request({
    url: '/role/moduleDetail',
    data
  })
}

// 保存角色权限
export function saveRoleModule(data) {
  return request({
    url: '/role/save',
    data
  })
}

// 获取授权列表
export function getLicenseList(data) {
  return request({
    url: '/inside/ai/license/list',
    data
  })
}

// 删除授权
export function deleteLicense(data) {
  return request({
    url: '/user/batchRemoveLicense',
    data
  })
}

// 添加授权
export function addLicense(data) {
  return request({
    url: '/user/batchAddLicense',
    data
  })
}

// 获取授权详情
export function getFeeLogDetail(data) {
  return request({
    url: '/feeLog/detail',
    data
  })
}

// 获取助手列表
export function getAssistantList(data) {
  return request({
    url: '/inside/assistantManagement/list',
    data
  })
}

// 获取助手列表状态详情
export function getAntOpenStatus(data) {
  return request({
    url: '/inside/ant/open/status',
    data
  })
}

// 编辑助手分配员工
export function editAssistant(data) {
  return request({
    url: '/inside/assistantManagement/edit',
    data
  })
}

// 获取数据源列表
export function getDataSourceList(data) {
  return request({
    url: '/inside/dataSourceManagement/list',
    data
  })
}

// 编辑数据源
export function editDataSource(data) {
  return request({
    url: '/inside/dataSourceManagement/edit',
    data
  })
}

// 获取字段配置列表
export function getFieldConfigList(data) {
  return request({
    url: '/inside/fieldConfig/list',
    data
  })
}

// 保存字段配置
export function saveFieldConfig(data) {
  return request({
    url: '/inside/fieldConfig/save',
    data
  })
}

// 校验助手管理编辑权限
export function hasRoleEdit(data) {
  return request({
    url: '/inside/ai/license/hasRoleEdit',
    data
  })
}

/**
 * 获取企业知识库列表
 * @param {Number} data.type  1、跟进助手 2、分析师
 * @returns
 */
export function getCompanyKnowledge(data) {
  return request({
    url: '/inside/module/knowledge/detail',
    data
  })
}

// 上传企业知识库
export function uploadCompanyKnowledge(data) {
  return request({
    url: '/inside/module/knowledge/upload',
    data
  })
}

/**
 * 删除企业知识文件
 * @param {Number} data.type  1、跟进助手 2、分析师
 * @param {Array} data.fileIdList
 * @returns
 */
export function delCompanyKnowledge(data) {
  return request({
    url: '/inside/module/knowledge/deleteFiles',
    data
  })
}

/**
 * 校验工牌设备是否可添加
 * @param {String} data.deviceNo 设备编号
 * @param {Number} data.type 1、胸牌 2、挂牌
 * @returns status 1 为正常
 */
export function checkAddBadge(data) {
  return request({
    url: '/inside/badge/add/check',
    data
  })
}

/**
 * 添加工牌设备
 * @param {Array} data.badgeList 工牌列表
 * @param {String} data.badgeList[].deviceNo 设备编号
 * @param {String} data.badgeList[].userId 用户ID
 * @param {Number} data.type 1、胸牌 2、挂牌
 * @returns
 */
export function addBadge(data) {
  return request({
    url: '/inside/badge/add',
    data
  })
}
